<template>
  <div class="main d-flex justify-center align-center">
    <v-form
      ref="signinForm"
      v-model="valid"
      :lazy-validation="lazy"
      class="signIn-form"
      @submit.prevent="submit"
    >
      <v-container>
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="form.email"
              validate-on-blur
              :rules="emailRules"
              label="E-mail"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
              :rules="emptyRules"
              v-model="form.password"
              label="Password"
              type="password"
              required
            ></v-text-field>
          </v-col>
        </v-row>
      </v-container>
      <v-btn
        :disabled="!valid"
        rounded
        :loading="loadingAuth"
        color="primary"
        type="submit"
      >Sign In</v-btn>
    </v-form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "SignIn",
  data() {
    return {
      valid: false,
      lazy: false,
      form: {
        email: "",
        password: "",
      },
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) =>
          /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i.test(
            v
          ) || "E-mail must be valid",
      ],
      emptyRules: [(v) => !!v || "This field is required"],
    };
  },
  methods: {
    ...mapActions({
      signIn: "auth/signIn",
      showHandlerSnackbar: "snackbar/showHandlerSnackbar",
    }),

    submit() {
      this.signIn(this.form)
        .then((res) => {
          this.showHandlerSnackbar({
            color: "success",
            text: res.message,
            show: true,
          });

          window.location.href = '/';
          // this.$router.push({
          //   name: "Home",
          // });
        })
        .catch((err) => {
          this.showHandlerSnackbar({
            color: "error",
            text: err.response.data.message,
            show: true,
          });
        });
    },
  },
  computed: {
    ...mapGetters({
      loadingAuth: "auth/loadingAuth",
      user: "auth/user",
    }),
  },
};
</script>

<style lang="scss">
.main {
  position: relative;
  width: 100%;
  height: 100%;
}
.signIn-form {
  position: relative;
  padding: 20px 25px;
  max-width: 300px;
  border: 1px solid #e9e9e9;
  border-radius: 10px;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 3px 3px -2px,
    rgba(0, 0, 0, 0.14) 0px 3px 4px 0px, rgba(0, 0, 0, 0.12) 0px 1px 8px 0px;
  margin: 0 auto;
  text-align: center;
}
</style>
